import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import {Col, Row} from 'reactstrap';
import CardDetalhe from '../../../comum/components/CardDetalhe';
import { formataParaDiaMesAno } from '../../../../utils/functions';
import * as moment from 'moment';
import { formatarCnpj } from '../../../../utils/formatar';

@inject("store")
@observer
class DetalheSolicitacao extends Component {
    constructor(props) {
        super(props);
        this.row = props.row;
        this.rowIndex = props.rowIndex;
    }
    
    verificaLog() {
        console.log(this.rowIndex)
        console.log(this.row)
    }


    render() { 
        return ( 
            
            <div className="container-card-detalhe">
                {this.verificaLog()}
                <div className="p-3">
                    <h4>Outros Detalhes</h4>
                    <Row className="m-0 no-gutters">
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                            <CardDetalhe 
                                titulo={this.row.ResponsavelCusto == "CLIENTE" ? this.row.RazaoResponsavelCusto : "-"}
                                label={"Cliente"}
                                desc={this.row.ResponsavelCusto == "CLIENTE" && this.row.CnpjResponsavelCusto != null ? formatarCnpj(this.row.CnpjResponsavelCusto) : ""}
                            />
                        </Col>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                            <CardDetalhe 
                                titulo={(this.row.NomeSolicitante || "Usuário do Terminal" )}
                                label={"Criado Por"}
                                desc={""}
                            />
                        </Col>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                            <CardDetalhe 
                                titulo={this.row.ResponsavelCusto}
                                label={"Responsável Custo"}
                                desc={this.row.ResponsavelCusto == "ARMADOR" ? this.row.Armador : ""}
                            />
                        </Col>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                            <CardDetalhe 
                                titulo={this.row.EmailSolicitante || "E-MAIL NÃO INFORMADO"}
                                label={"E-mail"}
                                desc={""}
                            />
                        </Col>
                        {/* <Col xs="12" sm="12" md="12" lg="8" xl="8"> */}
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                            <CardDetalhe 
                                titulo={"-"}
                                label={"Observação"}
                                desc={""}
                            />
                        </Col>
                        <Col xs="12" sm="12" md="6" lg="4" xl="4">
                            <CardDetalhe 
                                titulo={this.row.TipoServico}
                                label={"Tipo Serviço"}
                                desc={"-"}
                            />
                        </Col>
                    </Row>
                    <Row>
                    </Row>
                </div>
            </div>
         );
    }
}
 
export default DetalheSolicitacao;


// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/components/DetalheSolicitacao.js